<template>
    
    
<div class="container">

    <div class="alert alert-warning my-5 text-center">Mobile version is under development. Please open this website in a desktop computer.</div>

    <div class="alert alert-info text-center">
      <p>W3 Website Builder is under development.</p>
      <p>To access with a demo user, <a href="/demo">click here</a>.</p>
      <p>Contact: <a href="mailto:guilherme@scaalar.com">E-mail</a>.</p>
    </div>


</div>

</template>
<script>

  import Vue from 'vue'

  export default {
    name: 'mobile',
    data() {
      return {
      }
    },
    methods:{
    },
    mounted(){
        if(!isMobile()){
        this.$router.push('/');
        }

    }

  }



</script>

<style scoped>

</style>
